import styled from 'styled-components';

export const BackgroundContainerModal = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: var(--background-modal);
  z-index: 1;
  display: flex;
  justify-content: center;
  padding: 5rem 0 0;
  color: var(--text-body);

  > div {
    border-radius: 10px;
    padding: 1rem 1.5rem;
    display: flex;
    flex-direction: column;
    max-height: 30rem;
    width: 30rem;
    background-color: var(--white);
    overflow-y: auto;
    z-index: 2;
  }
`;

export const CloseButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;

  > svg {
    cursor: pointer;
  }
`;

export const HeaderModal = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  width: 100%;

  justify-content: center;
  border-bottom: 2px solid var(--black-light);

  > p {
    font-size: 1.2rem;
    padding: 1rem;
    font-weight: 700;
  }
`;

export const ContentModal = styled.div`
  padding: 1rem;
  height: 100%;
  overflow-y: auto;
  height: 10rem;
`;

export const ContainerButton = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const GradesToDeleteDescription = styled.span`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const ObsAlert = styled.span`
  color: var(--error);
  margin-bottom: 1rem;
`;

export const GradesToDeleteContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid var(--primary);
  > p {
    font-weight: 600;
  }
  > span {
    color: var(--primary);
    font-weight: 600;
  }
`;
